import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { FaTelegramPlane } from "react-icons/fa";
import { MaxMessengerBrandIcon } from "@/shared/ui/MaxMessengerBrandIcon/MaxMessengerBrandIcon";
const TelegramGlyph = FaTelegramPlane;
const TelegramNavIcon = ({ size = 20, color = "currentColor" }) => (_jsx(TelegramGlyph, { size: size, color: color }));
export const SOCIAL_ITEMS = [
    {
        href: "https://t.me/VirtuosRobot?start=menu_site",
        icon: TelegramNavIcon,
        label: "Telegram",
        clickTarget: "telegram_bot",
        utm: "menu_site",
    },
    {
        href: "https://max.ru/id550367227555_bot?start=menu_site",
        icon: MaxMessengerBrandIcon,
        label: "MAX",
        clickTarget: "max_bot",
        utm: "menu_site",
    },
];
